<form class="needs-validation" [formGroup]="myForm" novalidate>
   <app-validation-banner [form]="myForm" [show]="showBanner"></app-validation-banner>
   <div class="col-md-7 mb-3 pad-left">
      <label for="maintenanceType" class="bold">Type of Maintenance</label>
      <select class="custom-select" id="maintenanceType" formControlName="maintenanceType"  (change)="handleTypeChange($event);">
         <option selected disabled value="">- Select -</option>
         <option *ngFor="let enum of filter() | keyvalue: valueAscOrder" [value]="[(enum.value)]">
            <ng-container *ngIf="enum.value != 'License Change'">{{ enum.value | capital}}</ng-container>   
         </option>
      </select>
      <p class="err" *ngIf="myForm.controls['maintenanceType'].hasError('required') && myForm.controls['maintenanceType'].touched">
         Type of Maintenance
      </p>
   </div>

   <app-form-base [myForm]="myForm" [request]="request" [duplicated]="duplicated" (newModel)="updateRequest($event)" (newFile)="updateFile($event)" (newOptFile)="updateOptFile($event)"[group]="GROUP"></app-form-base>
   <label for ="description"> <p class="bold pad-left no-pad">Request Details</p></label>
   <p class="no-pad pad-left">Please be specific about your request.</p>
   <div class = "text-pad">
      <textarea class="col-12  fit" maxlength="5000" id="description" formControlName = "requestDetails" rows="10"></textarea>
   </div>
   <p class="err pad-left" *ngIf="myForm.controls['requestDetails'].hasError('required') && myForm.controls['requestDetails'].touched">
   Request Details are required
   </p>
   <p class="no-pad gray pad-left">{{myForm.controls['requestDetails'].value.length}} of 5,000 characters</p>
   <div class="section pad-left" id="date-picker">
      <div class="section-heading no-pad">
         <label for="date-picker-input">Desired Effective Date</label>
      </div>
      <div class="input-group no-pad date-pad">
         <input
            id="date-picker-input"
            type="text"
            placeholder="mm/dd/yyyy"
            aria-label="Desired Effective Date"
            class="form-control input-sm"
            formControlName = "effDate"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', adaptivePosition: true, showWeekNumbers:false}"
            #dp="bsDatepicker"
            bsDatepicker
            [outsideClick]="true"
            data-provide='datepicker'
            container='#date-picker'
            [minDate]='todayDate'
         />
         <div class="input-group-append">
            <button
               class="btn btn-default calendar"
               (click)="dp.toggle()"
               [attr.aria-expanded]="dp.isOpen"
               aria-label="calendar"
               ><fa-icon [icon]="faCalendar"></fa-icon
            ></button>
         </div>
      </div>
      <span class="err no-pad" *ngIf="myForm.controls['effDate'].hasError('required') && myForm.controls['effDate'].touched">
         Desired Effective Date is required
      </span>
   </div>
   <ng-container *ngIf="myForm.controls['maintenanceType'].value == TAXCHANGE">
      <label class="bold pad-left">Attach IRS Form W-9</label>
      <p class="no-pad pad-left">We require a completed copy of your IRS Form W-9 to process Tax ID changes.</p>

      <app-file-upload [myForm]="myForm" [doc]="doc" (newFile)="updateFile($event)"> </app-file-upload>
   </ng-container>
   <label class="bold pad-left">Attach Document 
      <span class="optional-tag no-bold"> (optional)</span>
   </label> 
   <p class="no-pad pad-left">If you have additional documents you would like to upload you can do so here.</p>

   <app-opt-file-upload [myForm]="myForm" *ngIf="optDocs" [optDocs]="optDocs" (newOptFile)="updateOptFile($event)"></app-opt-file-upload>
</form>
<app-add-request-button [group]="GROUP" [reqType]="reqToggle" [validated]="myForm.touched" (close)="closeParent($event)" (submit)="submit($event)"></app-add-request-button>
